var map = {
	"./3d.png": "5633",
	"./5a5.png": "4866",
	"./5w.png": "4724",
	"./6a3.png": "d191d",
	"./6a6.png": "d146",
	"./6aa.png": "1d16",
	"./6ab.png": "d76f",
	"./6ab3.png": "35af",
	"./6abc.png": "9037",
	"./6abc2.png": "91c3",
	"./6aw.png": "00a5",
	"./6bb.png": "d8ec",
	"./6s.png": "54f7",
	"./6w.png": "e998",
	"./7a7.png": "2fe1",
	"./7ab2.png": "26cc",
	"./7abb.png": "d01f",
	"./7abc.png": "74d4",
	"./7aw.png": "ad2b",
	"./7s.png": "7642",
	"./7w.png": "bc6b",
	"./8a4.png": "2bb5",
	"./8a8.png": "73c5",
	"./8aa.png": "26ff",
	"./8ab.png": "5146",
	"./8ab2.png": "03f8",
	"./8ab4.png": "c4e3",
	"./8abcd.png": "940a",
	"./8abcd2.png": "16ce",
	"./8aw.png": "290b",
	"./8b4.png": "6431",
	"./8b8.png": "d73b",
	"./8bb.png": "f9eb",
	"./8s.png": "26f4",
	"./8w.png": "d42e",
	"./A1.png": "d877",
	"./A1e.png": "4a4b",
	"./A2.png": "05f1",
	"./A2e.png": "766c",
	"./A3.png": "8205",
	"./A3e.png": "d83e",
	"./AA.png": "1215",
	"./AB.png": "5e0c",
	"./B1.png": "9653",
	"./B1e.png": "38ed",
	"./B2.png": "0a19",
	"./B2e.png": "1ac9",
	"./B3.png": "bca6",
	"./B3e.png": "d7a7",
	"./B4.png": "82b3",
	"./B4e.png": "6984",
	"./Bagsmart_BM0102004AN_layer.png": "8361",
	"./E_sleeveArea.png": "df2c",
	"./F_sleeveArea.png": "e3bf",
	"./IN-PROCESS logo.png": "6950",
	"./J_sleeveArea.png": "1737",
	"./K_sleeveArea.png": "a10b",
	"./Smartbag_BM0200107A_layer.png": "2af2",
	"./TOTEBAG_01_1.png": "48e6",
	"./TOTEBAG_01_2.png": "7a3c",
	"./TOTEBAG_02_1.png": "1cec",
	"./TOTEBAG_02_2.png": "4bbd",
	"./Thumbs_Up.svg": "f7dd",
	"./Umb66-1_sleeveArea.png": "0e29",
	"./Umb66-2_sleeveArea.png": "3e21",
	"./Umb68-1_sleeveArea.png": "a280",
	"./Umb68-2_sleeveArea.png": "852b",
	"./Umb70-1_sleeveArea.png": "3775",
	"./Umb70-2_sleeveArea.png": "6b26",
	"./Umb71-1_sleeveArea.png": "eeda",
	"./Umb71-2_sleeveArea.png": "8d88",
	"./addlogo.png": "3090",
	"./ar.png": "7a62",
	"./area_belt.png": "0546",
	"./area_logoend.png": "0822",
	"./area_logoside.png": "04cf",
	"./area_sleeve.png": "a546",
	"./area_umb.png": "7ad3",
	"./back.png": "ae5c",
	"./backside.png": "35c6",
	"./bg-handwrite.jpg": "5bcb",
	"./bg3d.jpg": "d9f89",
	"./btn-camera2.png": "4c03",
	"./btn-eye.png": "8142",
	"./btn-view3d.png": "808f",
	"./camera.png": "5e4f",
	"./cart.png": "ec17",
	"./cart_3d.png": "afcd",
	"./cart_checked.png": "0a05",
	"./cart_confirmed.png": "d522",
	"./cart_print.png": "9cd6",
	"./cart_share.png": "6134",
	"./cart_unchecked.png": "ad5f",
	"./close.png": "d991",
	"./color.png": "63a6",
	"./color3d.png": "8932",
	"./designArea.png": "bbe1",
	"./download.png": "96fc",
	"./download3d.png": "0e44",
	"./editImage.png": "6708",
	"./email.png": "d502",
	"./emoji.png": "da17",
	"./facebook.png": "5b2d",
	"./female.png": "d793",
	"./fold.png": "190f",
	"./fold_.png": "1ff1",
	"./fonts.png": "2b50",
	"./ftc.png": "e263",
	"./gallery.png": "a5ec",
	"./guide_5.png": "82d9",
	"./guide_6.png": "46e9",
	"./guide_7.png": "ec6a",
	"./guide_8.png": "e8b1",
	"./handle.png": "90ad",
	"./handwrite.png": "db2a",
	"./hat1_A.png": "dcc0",
	"./hat1_B.png": "e45e",
	"./hat1_C.png": "7e31",
	"./hat1_D.png": "f08b",
	"./hat1_E.png": "ee9d",
	"./hat2_A.png": "9400",
	"./hat2_B.png": "2307",
	"./hat2_C.png": "70de",
	"./hat2_D.png": "0690",
	"./hat_3abc.png": "426f",
	"./hat_6a2.png": "3d7e",
	"./hat_6a3.png": "4aa8",
	"./hat_6a6.png": "38d5",
	"./hat_6abc.png": "1d0a",
	"./hat_6s.png": "a455",
	"./hat_6w.png": "ee3e",
	"./help.png": "dfdd",
	"./history.png": "fc94",
	"./home.png": "28ea",
	"./home_pc.jpg": "4f2a",
	"./home_pc_yousee.jpg": "a53b",
	"./home_phone.jpg": "0e32",
	"./home_phone_yousee.jpg": "8ac0",
	"./hookcolor.png": "cb40",
	"./icon_Golf.png": "0ad6",
	"./ins.png": "8724",
	"./insidecolor.png": "040c",
	"./knob.png": "fa85",
	"./kuapian.png": "3331",
	"./landscape.jpg": "d6cb",
	"./line.png": "fe82",
	"./linecolor.png": "58c0",
	"./link.png": "6ad3",
	"./lit.jpg": "e836",
	"./logo_ShareUC_yousee.jpg": "ebf5",
	"./logo_aurora.png": "4145",
	"./logo_ftc.png": "7735",
	"./logo_knirps.png": "5af8",
	"./logo_plune.png": "bce3",
	"./logo_shareuc.png": "d172",
	"./logo_test.png": "0fac",
	"./logo_yousee.png": "41b6",
	"./male.png": "fa9b",
	"./mirror.png": "d5f0",
	"./oa.png": "a6b3",
	"./open.png": "b93d",
	"./open_.png": "cf87",
	"./ow.png": "8f8d",
	"./pantone.png": "e614",
	"./patterns.png": "016a",
	"./pinterest.png": "952b",
	"./platform-facebook.png": "aaaa",
	"./platform-instagram.png": "1777",
	"./platform-line.png": "9d06",
	"./platform-wechat.png": "4ad1",
	"./product_bag.png": "a266",
	"./product_gift.png": "2016",
	"./product_scarf.png": "224f",
	"./product_umb.png": "54cf",
	"./redline.png": "6b13",
	"./redo.png": "abdb",
	"./remove.png": "decf",
	"./removeImage.png": "2110",
	"./resize.png": "5c8f",
	"./rotate.png": "dcdb",
	"./rotation.png": "b971",
	"./ruler_Rotate.png": "6ece9",
	"./ruler_Zoom.png": "12ac",
	"./scarf.png": "3e1e",
	"./scarf/B1.png": "1de8",
	"./scarf/B1e.png": "77bd",
	"./scarf/B2.png": "1e1a",
	"./scarf/B2e.png": "37b5",
	"./scarf/B3.png": "f5d2",
	"./scarf/B3e.png": "b1b4",
	"./scarf/B4.png": "5ca7",
	"./scarf/B4e.png": "1283",
	"./setUmbDiameter.png": "75dc",
	"./share.png": "8a16",
	"./silkA_1.png": "d659",
	"./silkA_2.png": "4701",
	"./silkA_3.png": "de5b",
	"./silkA_4.png": "cf5a",
	"./silkB_1.png": "4832",
	"./silkB_2.png": "3d4f",
	"./silkB_3.png": "56fb",
	"./silkB_4.png": "75cd",
	"./silkC_1.png": "029d",
	"./silkC_2.png": "48a7",
	"./silkC_3.png": "bb0b",
	"./silkC_4.png": "b662",
	"./silkD_1.png": "1722",
	"./silkD_2.png": "8f1d",
	"./silkD_3.png": "af5d",
	"./silkD_4.png": "a587",
	"./silkF_1.png": "3685",
	"./silkF_2.png": "21f8",
	"./silkF_3.png": "360f",
	"./sleeve.png": "ca52",
	"./sleeve_.png": "3103",
	"./sleeve_2d.png": "fd81",
	"./sliderbg.png": "e342",
	"./standard.jpg": "20d8",
	"./switch.png": "a698",
	"./transparent.png": "cc31",
	"./twitter.png": "9284",
	"./umb.png": "b0db",
	"./undo.png": "93af",
	"./white.png": "5116",
	"./zoom.png": "9e8b",
	"./zoomin.png": "89f6",
	"./zoomout.png": "657f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";